import { render, staticRenderFns } from "./ListKonto.vue?vue&type=template&id=30bdf972&scoped=true&"
import script from "./ListKonto.vue?vue&type=script&lang=js&"
export * from "./ListKonto.vue?vue&type=script&lang=js&"
import style0 from "./ListKonto.vue?vue&type=style&index=0&id=30bdf972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bdf972",
  null
  
)

component.options.__file = "ListKonto.vue"
export default component.exports